
import startApp from "../../entry";
import lowcodePage from "./LowCode.vue";

startApp(lowcodePage);
